import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";

type Size = "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "prose";

/**
 * Container — wrapper centré, largeurs alignées sur les standards pros 2025.
 *
 *   sm    640px   — formulaires courts (auth)
 *   md    768px   — articles, pages légales (lecture confortable)
 *   lg    1024px  — pages mixtes
 *   xl    1280px  ⭐ DÉFAUT — homepage, hubs, listings (Doctolib/Healthline/Le Monde)
 *   2xl   1440px  — dashboards admin/pro larges
 *   full  100%    — sections bleed (hero gradients full-bleed)
 *   prose 70ch    — corps d'article pur typo
 *
 * Padding latéral progressif : 16px mobile → 24px md → 32px lg pour aération.
 */

const sizeMap: Record<Size, string> = {
  sm: "max-w-[var(--container-sm)]",
  md: "max-w-[var(--container-md)]",
  lg: "max-w-[var(--container-lg)]",
  xl: "max-w-[var(--container-xl)]",
  "2xl": "max-w-[var(--container-2xl)]",
  full: "",
  prose: "max-w-[var(--container-prose)]",
};

export function Container({
  size = "xl",
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { size?: Size }) {
  return (
    <div
      className={cn(
        "mx-auto w-full px-4 sm:px-6 lg:px-8",
        sizeMap[size],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
